import React from "react";
import { useSelector } from "react-redux";
import { LinkedIn } from "../icons/all/linkedin";
import { Instagram } from "../icons/all/instagram";
import { Twitter } from "../icons/all/twitter";
import { Phone } from "../icons/all/phone";
export function Information() {
	const { tenant } = useSelector(({ auth }) => auth);
	return (
		<div className="hidden md:flex flex-col grow shrink-0 basis-5/12 rounded-l-2xl shadow-lg overflow-hidden relative min-h-screen">
			{/* Background Image (with overlay baked in) */}
			<img
				src="/auth/auth-img.svg"
				alt="InvestorMatch Auth"
				className="absolute inset-0 w-full h-full object-cover z-0"
			/>
			{/* Content Overlay */}
			<div className="relative z-10 h-full w-full">
				{/* InvestorMatch Title */}
				<h1 className="absolute left-[40px] top-[32px] text-[48px] font-playfair italic text-white drop-shadow-lg leading-none">
					InvestorMatch
				</h1>
				{/* Circles and overlay text - pixel-perfect absolute positioning */}
				{/* 1st circle: Let us know your requirement */}
				<div className="absolute left-[15vw] top-[8vw] flex flex-col items-center w-[220px]">
					<img src="/auth/circle.svg" alt="circle" className="w-[54px] h-[54px] mb-2" />
					<span className="text-white text-[20px] font-inter text-center leading-tight drop-shadow-md">Let us know your requirement</span>
				</div>
				{/* 2nd circle: Save time, money, and make successful connections */}
				<div className="absolute left-[26vw] transform -translate-x-1/2 top-[24vw] flex flex-col items-center w-[320px]">
					<img src="/auth/circle.svg" alt="circle" className="w-[54px] h-[54px] mb-2" />
					<span className="text-white text-[20px] font-inter text-center leading-tight drop-shadow-md">Save time, money, and make successful connections</span>
				</div>
				{/* 3rd circle: Get high fidelity matches */}
				<div className="absolute right-[27vw] bottom-[28vw] flex flex-col items-center w-[220px]">
					<img src="/auth/circle.svg" alt="circle" className="w-[54px] h-[54px] mb-2" />
					<span className="text-white text-[20px] font-inter text-center leading-tight drop-shadow-md">Get high fidelity matches</span>
				</div>
				{/* Bottom section */}
				<div className="absolute left-0 bottom-0 w-full px-8 pb-8">
					<div className="mb-4">
						<span className="text-white font-bold text-lg font-inter">InvestorMatch.ai™</span>
						<ul className="text-white text-base mt-2 space-y-2 font-inter">
							<li className="flex items-center"><span className="inline-block w-3 h-3 rounded-full bg-white mr-3" />Matching Founders to Funders</li>
							<li className="flex items-center"><span className="inline-block w-3 h-3 rounded-full bg-white mr-3" />Automated due diligence for funders</li>
							<li className="flex items-center"><span className="inline-block w-3 h-3 rounded-full bg-white mr-3" />Vendor introductions</li>
						</ul>
					</div>
					<div className="flex space-x-4 items-center mt-2">
						<a href="#" className="bg-white text-[#446475] rounded-full p-2 transition"><span className="sr-only">Contact us</span><Phone size="34px" />  <span className="text-sm font-inter"> Contat us</span></a>
						<a href="#" className="bg-white text-[#446475] rounded-full p-2 transition mx-auto w-fit"><span className="sr-only">X</span><Twitter size="34px" classname="mx-auto" /></a>
						<a href="#" className="bg-white text-[#446475] rounded-full p-2 transition"><span className="sr-only">LinkedIn</span><LinkedIn /></a>
						<a href="#" className="bg-white text-[#446475] rounded-full p-2 transition"><span className="sr-only">Instagram</span><Instagram /></a>
					</div>
				</div>
			</div>
		</div>
	);
}
